import { render, staticRenderFns } from "./ExpandedRow.vue?vue&type=template&id=732130d2&scoped=true"
import script from "./ExpandedRow.vue?vue&type=script&lang=js"
export * from "./ExpandedRow.vue?vue&type=script&lang=js"
import style0 from "./ExpandedRow.vue?vue&type=style&index=0&id=732130d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732130d2",
  null
  
)

export default component.exports